import { useState } from "react";
import IconClose from "../../common/icons/IconClose";
import "./ReportPanel.css";
import { AI_BASE_URL } from "../../config/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const REPORT_TYPES = [
  { value: "bug", label: "Bug" },
  { value: "feedback", label: "Retour d'expérience" },
  { value: "feature", label: "Demande de fonctionnalité" },
  { value: "incident", label: "Incident" },
  { value: "inappropriate_content", label: "Contenu inapproprié" },
];

const getBrowserNameAndVersion = () => {
  const userAgent = navigator.userAgent;
  let match =
    userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+(\.\d+)?)/i
    ) || [];
  let temp;

  if (/trident/i.test(match[1])) {
    temp = /\brv[ :]+(\d+(\.\d+)?)/g.exec(userAgent) || [];
    return `IE ${temp[1] || ""}`.trim();
  }

  if (match[1] === "Chrome") {
    temp = userAgent.match(/\b(OPR|Edg|Edge)\/(\d+(\.\d+)?)/);
    if (temp != null) {
      return temp
        .slice(1)
        .join(" ")
        .replace("OPR", "Opera")
        .replace("Edg", "Edge");
    }
  }

  match = match[2]
    ? [match[1], match[2]]
    : [navigator.appName, navigator.appVersion, "-?"];
  if ((temp = userAgent.match(/version\/(\d+(\.\d+)?)/i)) != null) {
    match.splice(1, 1, temp[1]);
  }

  return match.join(" ").trim();
};

const ReportPanel = ({ show, togglePanel, userId, token, reviewId, email }) => {
  const [type, setType] = useState("feedback");
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return;

    if (!content || !userId) {
      toast.error("Veuillez remplir tous les champs.");
      return;
    }

    setIsSubmitting(true);

    try {
      const reportEmail =
        Array.isArray(email) && email.length > 0 ? email[0].email : email;

      const response = await fetch(`${AI_BASE_URL}/reports`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId,
          type,
          content,
          email: reportEmail,
          review_id: reviewId,
          browser: getBrowserNameAndVersion(),
        }),
      });

      if (response.ok) {
        toast.success("Signalement envoyé avec succès !");
        setType("feedback");
        setContent("");
        togglePanel();
      } else {
        toast.error("Erreur lors de l’envoi du rapport.");
      }
    } catch (error) {
      toast.error("Erreur réseau lors de l’envoi.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className="report-panel-overlay" onClick={togglePanel}>
      <div className="report-panel open" onClick={(e) => e.stopPropagation()}>
        <div className="report-panel-header">
          <h3>Créer un rapport</h3>
          <div className="report-panel-close" onClick={togglePanel}>
            <IconClose />
          </div>
        </div>

        <div className="report-panel-content">
          <div className="report-input">
            <label htmlFor="report-type">Type :</label>
            <select
              id="report-type"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              {REPORT_TYPES.map((option) => (
                <option key={option.label} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="report-input">
            <label htmlFor="report-content">Description :</label>
            <textarea
              id="report-content"
              rows={10}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
        </div>

        <div className="report-panel-buttons">
          <button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "ENVOI EN COURS..." : "ENVOYER LE RAPPORT"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportPanel;
